'use strict';

import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

const SELECTOR = '.js-review-scroller';

export function initialiseElement(element) {
    const scrollerElement = element.querySelector('.swiper-container');

    const settings = {
        slidesPerView: '1',
        grabCursor: false,
        effect: 'fade',
        crossFade: 'true',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletElement: 'button',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
        },
        modules: [Pagination, Autoplay, EffectFade],
    };

    // Initialize Swiper instance
    const swiperInstance = new Swiper(scrollerElement, settings);

    // Function to stop autoplay
    function stopAutoplay() {
        const stopAutoplayButton = document.querySelector('.review__stop-autoplay');
        const icon = stopAutoplayButton.querySelector('.o-icon');
        const iconUseElement = stopAutoplayButton.querySelector('use');
        const playTitle = stopAutoplayButton.querySelector('.review__play-title');
        const pauseTitle = stopAutoplayButton.querySelector('.review__pause-title');

        if (swiperInstance.autoplay.running) {
            swiperInstance.autoplay.stop();  // Stop autoplay
            icon.classList.remove('o-icon--pause-circle');
            icon.classList.add('o-icon--play-circle');
            iconUseElement.setAttribute('xlink:href', '#play-circle');
            playTitle.style.display = 'inline'; // Show Play title
            pauseTitle.style.display = 'none';  // Hide Pause title

        } else {
            swiperInstance.autoplay.start(); // Start autoplay
            console.log('Autoplay started');
            icon.classList.remove('o-icon--play-circle');
            icon.classList.add('o-icon--pause-circle');
            iconUseElement.setAttribute('xlink:href', '#pause-circle');
            playTitle.style.display = 'none';  // Hide Play title
            pauseTitle.style.display = 'inline'; // Show Pause title
        }
    }

    // Attach the click event handler to the button that will stop autoplay
    const stopAutoplayButton = document.querySelector('.review__stop-autoplay');
    if (stopAutoplayButton) {
        stopAutoplayButton.addEventListener('click', stopAutoplay);
    }
}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}
